import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  staticContent: [],
  totalStaticContentPages: 0,
  totalStaticContentItems: 0
}

const getters = {
  staticContent: state => state.staticContent,
  totalStaticContentPages: state => state.totalStaticContentPages,
  totalStaticContentItems: state => state.totalStaticContentItems
}

const actions = {
  async fetchStaticContent ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.staticContent.getContent())
      commit(types.SET_STATIC_CONTENT, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to load static content')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateStaticContent ({ commit }, content) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.staticContent.putContent(), { ...content })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Static content was updated successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Static content wasn\'t updated')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async createStaticContent ({ commit }, content) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.staticContent.postContent(), { ...content })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Static content was created successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Static content wasn\'t created')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteStaticContent ({ commit }, ids) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.staticContent.deleteContent(ids))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Static content was deleted successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Static content wasn\'t deleted')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_STATIC_CONTENT] (state, { staticPagesContent, totalPages, totalItems }) {
    state.staticContent = staticPagesContent
    state.totalStaticContentPages = totalPages
    state.totalStaticContentItems = totalItems
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/static-content.js